module.exports = __webpack_public_path__ + "static/media/image_58.b574a963.png";